import { render, staticRenderFns } from "./report-box-new.vue?vue&type=template&id=1d1aebef"
import script from "./report-box-new.vue?vue&type=script&lang=ts"
export * from "./report-box-new.vue?vue&type=script&lang=ts"
import style0 from "./report-box-new.vue?vue&type=style&index=0&id=1d1aebef&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d1aebef')) {
      api.createRecord('1d1aebef', component.options)
    } else {
      api.reload('1d1aebef', component.options)
    }
    module.hot.accept("./report-box-new.vue?vue&type=template&id=1d1aebef", function () {
      api.rerender('1d1aebef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/report-box-new/report-box-new.vue"
export default component.exports